// extracted by mini-css-extract-plugin
export default {"container":"PasswordInavlidToken_container__AQ1GJ"};